import styled from 'styled-components';

interface statusProps {
  status?: 'opened' | 'paid out' | 'overdue';
}

export const ContentRight = styled.div`
  width: 100%;
  grid-area: content-right;
`;

export const HeaderStatusServices = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 30px;

  #service {
    font-weight: 500;
    color: #000000;
    font-size: 20px;
  }

  #flat {
    color: #004ba5;
    font-size: 20px;
  }
`;

export const ContentStatusServices = styled.div`
  width: 100%;
  display: flex;
  gap: 15px;
  align-items: center;
  margin-bottom: 40px;
`;

export const Cards = styled.div`
  width: 100%;
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
`;

export const StatusServices = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  gap: 5px;
  line-height: 18px;

  p {
    color: #000000;
    font-size: 16px;
  }

  text {
    color: #7a7a7a;
  }
`;

export const Status = styled.strong<statusProps>`
  color: ${props => {
    switch (props.status) {
      case 'paid out':
        return '#5BC766';
      case 'overdue':
        return '#EC5C52';
      case 'opened':
        return '#004BA5';
      default:
        return 'none';
    }
  }};
`;
